import { label as o } from "./label.js";
import { switchStyles as t, switchThumb as r } from "./switch.js";
import { checkboxStyles as i, checkboxIndicator as c } from "./checkbox.js";
import { radioButtonStyles as m, radioButtonIndicator as e } from "./radio.js";
import { input as s } from "./input.js";
const b = {
  label: o,
  switch: t,
  switchThumb: r,
  checkbox: i,
  checkboxIndicator: c,
  radio: m,
  radioButtonIndicator: e,
  ...s
};
export {
  b as forms
};
